import HomePageRoute from "./HomePageRoute";

const routes = [
    new HomePageRoute()
]

export default routes